// @ts-nocheck
document.addEventListener("alpine:init", () => {
  Alpine.data("bundles", ({ currency, progressBar }) => ({
    loaded: false,
    currency,
    progressBar,
    selectedCollection: "all",
    selectedProduct: null,
    isSubscription: false,
    boxDiscountType: "percent",
    subscriptionDiscount: 15,
    bundleDiscount: 15,
    currentSellingPlan: null,
    savingPercentage: null,
    savingAmount: null,
    slots: [],
    totalSlotsQuantity: 0,
    maxQty: 99,
    minQty: 0,
    progressBarWidth: 0,
    selectedFilter: "*",
    bundleProducts: window.bundleProducts,
    originalTotalPrice: 0,
    originalTotalPriceWithBundleSavings: 0,
    totalPrice: 0,
    totalPriceWithDiscount: 0,
    totalPriceWithDiscountOtp: 0,
    disableAddToCartButton: false,
    freeShippingRemaining: 0,
    isScrolledToBottom: false,
    isScrolledToTheProduct: false,
    sellingItemIncluded: false,

    init() {
      this.loaded = true;
      // Set initial selling plan if available
      const url = new URL(window.location.href);
      const searchParams = new URLSearchParams(url.search);
      const selectElement = document.querySelector(
        '[name="frequency_selling_plan"]'
      );
      if (selectElement) {
        this.currentSellingPlan = selectElement.value;
      }

      if (searchParams.get("collection")) {
        this.setCollection(searchParams.get("collection"));
      }
      if (searchParams.get("selected_product")) {
        this.setSelectedProduct(Number(searchParams.get("selected_product")));
      }
    },

    setFilter(filter) {
      this.selectedFilter = filter;
    },

    setCollection(collectionId) {
      this.selectedCollection = collectionId;
      const url = new URL(window.location.href);
      const searchParams = new URLSearchParams(url.search);
      searchParams.set("collection", collectionId);
      url.search = searchParams.toString();
      window.history.pushState({}, "", url);
    },

    setSelectedProduct(productId) {
      const url = new URL(window.location.href);
      const searchParams = new URLSearchParams(url.search);

      if (this.selectedProduct === productId) {
        this.selectedProduct = null;
        searchParams.delete("selected_product");
      } else {
        this.selectedProduct = Number(productId);
        searchParams.set("selected_product", this.selectedProduct);
      }

      if (!this.isScrolledToTheProduct) {
        this.scrollToTheProduct(this.selectedProduct);
      }

      url.search = searchParams.toString();
      window.history.pushState({}, "", url);

      this.$dispatch("bundle-product-changed", {
        productId: this.selectedProduct,
      });
    },

    /**
     * Scroll to the product in the bundle on page load
     * @param {number} productId - The product ID
     */
    scrollToTheProduct(productId) {
      this.isScrolledToTheProduct = true;
      if (this.selectedProduct !== productId) {
        return;
      }

      const product = document.querySelector(
        `[data-bundle-product-id="${this.selectedProduct}"]`
      );
      if (!product) {
        return;
      }

      this.$el?.querySelector("[data-scroll-wrapper]")?.scrollTo({
        top: product.offsetTop - 1, // -1 to account for the border-top
        behavior: "instant",
      });
    },
    includeSellingItem(productId) {
      this.sellingItemIncluded = !this.sellingItemIncluded;

      this.sellingItemData = {
        productId: productId,
        quantity: 1,
      };
    },

    getExtraDiscountInfo() {
      const discountInfo = {
        discountCode: "",
        discountCodeOtp: "",
        discountAmountOtp: 0,
        discountMultiplier: 1,
      };

      if (!this.progressBar) {
        return discountInfo;
      }

      const isNotEnoughQty =
        this.totalSlotsQuantity < this.progressBar.secondDotQty;
      const isFirstDiscount =
        this.totalSlotsQuantity >= this.progressBar.secondDotQty &&
        this.totalSlotsQuantity < this.progressBar.maxProgressBarQty;
      const isSecondDiscount =
        this.totalSlotsQuantity >= this.progressBar.maxProgressBarQty;

      const isEligibleForDiscount =
        this.progressBar.discountCode1 && this.progressBar.discountCode2;

      const isEligibleForDiscountOtp =
        this.progressBar.discountCode1Otp && this.progressBar.discountCode2Otp;

      if (isNotEnoughQty) {
        return discountInfo;
      }

      if (isSecondDiscount) {
        isEligibleForDiscount
          ? (discountInfo.discountCode = this.progressBar.discountCode2)
          : (discountInfo.discountCode = "");
        isEligibleForDiscount
          ? (discountInfo.discountMultiplier =
              1 - this.progressBar.discountAmount2 / 100)
          : 1;

        isEligibleForDiscountOtp
          ? (discountInfo.discountCodeOtp = this.progressBar.discountCode2Otp)
          : (discountInfo.discountCodeOtp = "");

        isEligibleForDiscountOtp
          ? (discountInfo.discountAmountOtp =
              this.progressBar.discountAmount2Otp)
          : (discountInfo.discountAmountOtp = 0);
      }

      if (isFirstDiscount) {
        isEligibleForDiscount
          ? (discountInfo.discountCode = this.progressBar.discountCode1)
          : (discountInfo.discountCode = "");

        isEligibleForDiscount
          ? (discountInfo.discountMultiplier =
              1 - this.progressBar.discountAmount1 / 100)
          : 1;

        isEligibleForDiscountOtp
          ? (discountInfo.discountCodeOtp = this.progressBar.discountCode1Otp)
          : (discountInfo.discountCodeOtp = "");

        isEligibleForDiscountOtp
          ? (discountInfo.discountAmountOtp =
              this.progressBar.discountAmount1Otp)
          : (discountInfo.discountAmountOtp = 0);
      }
      return discountInfo;
    },

    updatePrices() {
      if (!this.slots || !this.slots.length) return;

      this.originalTotalPrice = this.slots.reduce(
        (accumulator, currentObject) => {
          return accumulator + currentObject.price * currentObject.quantity;
        },
        0
      );

      if (this.progressBar.useQtyForOtp && !this.isSubscription) {
        const discountPriceOtp =
          this.originalTotalPrice -
          this.getExtraDiscountInfo().discountAmountOtp;
        this.totalPriceWithDiscountOtp =
          discountPriceOtp === this.originalTotalPrice ? 0 : discountPriceOtp;
      }

      const bundleDiscount =
        this.totalSlotsQuantity > 1 ? this.bundleDiscount : 0;

      // Calculate discounted prices with proper rounding at each step
      const subscriptionMultiplier = 1 - this.subscriptionDiscount / 100;

      const extraDiscountMultiplier =
        this.getExtraDiscountInfo().discountMultiplier;

      const bundleMultiplier = 1 - bundleDiscount / 100;
      const bundleDiscountAmount = bundleDiscount * 100;

      if (this.boxDiscountType === "fixed") {
        this.totalPriceWithDiscount = Math.round(
          this.originalTotalPrice * subscriptionMultiplier -
            bundleDiscountAmount
        );
        this.originalTotalPriceWithBundleSavings =
          this.originalTotalPrice - bundleDiscountAmount;

        if (this.currentSellingPlan) {
          this.totalPrice = Math.round(
            this.originalTotalPrice * subscriptionMultiplier -
              bundleDiscountAmount
          );
          this.savingPercentage = bundleDiscount + this.subscriptionDiscount;
        } else {
          this.totalPrice = Math.round(
            this.originalTotalPrice - bundleDiscountAmount
          );
          this.savingPercentage = bundleDiscount;
        }
        return;
      }

      if (this.boxDiscountType === "percent") {
        this.totalPriceWithDiscount = Math.round(
          this.originalTotalPrice *
            subscriptionMultiplier *
            extraDiscountMultiplier
        );
        this.originalTotalPriceWithBundleSavings =
          this.originalTotalPrice * extraDiscountMultiplier;
        if (this.currentSellingPlan) {
          this.totalPrice = Math.round(
            this.originalTotalPrice *
              subscriptionMultiplier *
              extraDiscountMultiplier
          );
          this.savingPercentage = bundleDiscount + this.subscriptionDiscount;
        } else {
          this.totalPrice = Math.round(
            this.originalTotalPrice * extraDiscountMultiplier
          );
          this.savingPercentage = bundleDiscount;
        }
      }

      this.savingAmount = Math.round(this.originalTotalPrice - this.totalPrice);
    },

    getSavingPercentage() {
      if (this.totalSlotsQuantity > 1) {
        return this.bundleDiscount + this.subscriptionDiscount;
      } else {
        return this.subscriptionDiscount;
      }
    },

    getSubscriptionMessage() {
      if (this.totalSlotsQuantity === 0) {
        return "Save 10% when you subscribe";
      } else {
        return "Save an extra 10% off 2+ Packs";
      }
    },

    moneyFormat(price) {
      const numericPrice = (+price / 100).toFixed(2);
      return `${this.currency.symbol}${numericPrice} ${this.currency.isoCode}`;
    },

    onUpdateSlots() {
      this.countSlotsQuantity();
      this.updatePrices();
      this.updateProgressBar();
      this.updateProgressBarWidth();
    },

    updateSlots(productId, variantId, qty) {
      const slotObj = this.bundleProducts.find(
        (product) => product.productId === productId
      );
      const foundSlot = this.slots.find((slot) => slot.productId === productId);

      if (foundSlot) {
        foundSlot.quantity = qty;
      } else {
        slotObj.quantity = qty;
        this.slots.push(slotObj);
      }

      this.onUpdateSlots();
    },

    countSlotsQuantity() {
      if (!this.slots || !this.slots.length) return 0;
      this.totalSlotsQuantity = 0;
      this.slots.forEach((slot) => {
        this.totalSlotsQuantity += slot.quantity;
      });
    },

    updateSellingPlan(value) {
      this.currentSellingPlan = value;
    },

    updateProgressBarWidth() {
      if (!this.slots || !this.slots.length) {
        this.progressBarWidth = 0;
        this.totalSlotsQuantity = 0;
        return;
      }

      if (this.isSubscription || this.progressBar.useQtyForOtp) {
        const step = (100 / this.progressBar.maxProgressBarQty).toFixed(2);
        const amountInPercent = this.totalSlotsQuantity * step;
        this.progressBarWidth = amountInPercent > 100 ? 100 : amountInPercent;
        return;
      }

      // Calculate progress based on remaining amount needed for free shipping
      const currentAmount = this.originalTotalPrice;
      const remainingAmount = Math.max(
        0,
        this.progressBar.freeShippingThreshold - currentAmount
      );
      const progressPercentage = Math.min(
        100,
        ((this.progressBar.freeShippingThreshold - remainingAmount) /
          this.progressBar.freeShippingThreshold) *
          100
      );
      this.freeShippingRemaining = remainingAmount;
      this.progressBarWidth = progressPercentage;
    },

    updateProgressBar() {
      if (this.isSubscription) {
        const totalSlotQTY = this.totalSlotsQuantity;
        const subscriptionBundleMessages = [
          {
            qty: this.progressBar.firstDotQty,
            message: this.progressBar.message1,
          },
          {
            qty: this.progressBar.secondDotQty,
            message: this.progressBar.message2,
          },
          {
            qty: this.progressBar.maxProgressBarQty,
            message: this.progressBar.message3,
          },
        ];

        const activeMessage = subscriptionBundleMessages.reduce(
          (highest, current) => {
            if (
              +totalSlotQTY >= +current.qty &&
              (!highest || current.qty >= highest.qty)
            ) {
              return current;
            }
            return highest;
          },
          null
        );

        if (!activeMessage) {
          // Return the first tier's message if no threshold is met
          return subscriptionBundleMessages[0].message;
        }
        return activeMessage.message;
      }

      if (this.progressBar.useQtyForOtp) {
        const totalSlotQTY = this.totalSlotsQuantity;
        const bundleMessagesOTP = [
          {
            qty: this.progressBar.firstDotQty,
            message: this.progressBar.message1Otp,
          },
          {
            qty: this.progressBar.secondDotQty,
            message: this.progressBar.message2Otp,
          },
          {
            qty: this.progressBar.maxProgressBarQty,
            message: this.progressBar.message3Otp,
          },
        ];

        const activeMessageOTP = bundleMessagesOTP.reduce(
          (highest, current) => {
            if (
              +totalSlotQTY >= +current.qty &&
              (!highest || current.qty >= highest.qty)
            ) {
              return current;
            }
            return highest;
          },
          null
        );

        if (!activeMessageOTP) {
          // Return the first tier's message if no threshold is met
          return bundleMessagesOTP[0].message;
        }
        return activeMessageOTP.message;
      }

      if (this.originalTotalPrice == 0) {
        return this.progressBar.freeShippingText;
      } else if (this.freeShippingRemaining > 0) {
        return this.progressBar.freeShippingRemainingText.replace(
          "[amount]",
          this.moneyFormat(this.freeShippingRemaining)
        );
      } else if (this.freeShippingRemaining == 0) {
        return this.progressBar.freeShippingReachedText;
      }
    },

    updateProgressBarDotPosition() {
      switch (this.totalSlotsQuantity) {
        case 0:
          return "left: 0";
        case 1:
          return `left: calc(${this.progressBarWidth}%)`;
        default:
          return `left: calc(${this.progressBarWidth}%)`;
      }
    },

    updateSavingsTextPosition() {
      if (!this.isSubscription) return;
      switch (this.totalSlotsQuantity) {
        case 0:
          return "display: none;";
        case 3:
          return `left: calc(${this.progressBarWidth}% - 80px)`;
        default:
          return `left: calc(${this.progressBarWidth}% - 155px)`;
      }
    },

    addToCart(event) {
      if (!this.slots || !this.totalSlotsQuantity) return;
      this.disableAddToCartButton = true;
      const cartItemsComponents = document.querySelectorAll(
        "cart-items-component"
      );
      let cartItemComponentsSectionIds = [];

      cartItemsComponents.forEach((item) => {
        if (item instanceof HTMLElement && item.dataset.sectionId) {
          cartItemComponentsSectionIds.push(item.dataset.sectionId);
        }
      });

      const body = {
        items: [],
        sections: cartItemComponentsSectionIds.join(","),
        // sections_url: window.location.pathname,
      };

      if (this.sellingItemIncluded) {
        body.items.push({
          id: this.sellingItemData.productId,
          quantity: this.sellingItemData.quantity,
        });
      }

      if (this.isSubscription) {
        this.slots.forEach((slot) => {
          let properties = {};

          if (this.getExtraDiscountInfo().discountCode) {
            properties._offer = this.getExtraDiscountInfo().discountCode;
          }
          body.items.push({
            id: slot.variantId,
            quantity: slot.quantity,
            selling_plan: parseInt(this.currentSellingPlan),
            properties,
          });
        });
      } else {
        let properties = {};
        if (this.getExtraDiscountInfo().discountCodeOtp) {
          properties._offer = this.getExtraDiscountInfo().discountCodeOtp;
        }

        this.slots.forEach((slot) => {
          body.items.push({
            id: slot.variantId,
            quantity: slot.quantity,
            properties,
          });
        });
      }

      const fetchCfg = fetchConfig("json", {
        body: JSON.stringify(body),
      });

      fetch(Theme.routes.cart_add_url, {
        ...fetchCfg,
        headers: {
          ...fetchCfg.headers,
          Accept: "text/html",
        },
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            window.dispatchEvent(
              new CartErrorEvent(
                this.$refs.addToCartButton.id,
                response.message
              )
            );

            window.dispatchEvent(
              new CartAddEvent({}, this.$refs.addToCartButton.id, {
                didError: true,
                source: "build-a-box",
                itemCount: Number(body.items.length),
                productIds: this.slots.map((slot) => slot.productId),
              })
            );

            return;
          } else {
            const sectionId = document.querySelector("cart-items-component")
              ?.dataset.sectionId;

            const newSectionHTML = new DOMParser().parseFromString(
              response.sections[sectionId],
              "text/html"
            );

            // Grab the new cart item count from a hidden element
            const newCartHiddenItemCount = newSectionHTML.querySelector(
              '[ref="cartItemCount"]'
            )?.textContent;

            const newCartItemCount = newCartHiddenItemCount
              ? parseInt(newCartHiddenItemCount, 10)
              : 0;

            morphSection(sectionId, response.sections[sectionId]);

            window.dispatchEvent(
              new CartAddEvent({}, this.$refs.addToCartButton.id, {
                source: "build-a-box",
                itemCount: Number(body.items.length),
                productIds: this.slots.map((slot) => slot.productId),
                sections: response.sections,
              })
            );
          }
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          // add more thing to do in here if needed.
          this.disableAddToCartButton = false;
          cartPerformance.measureFromEvent("add:user-action", event);
        });
    },

    isMaxQuantityReached() {
      return this.totalSlotsQuantity >= this.maxQty;
    },
  }));
});
